import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import type { Aluno } from '../services/alunosService';
import { alunosService } from '../services/alunosService';
import styles from './AlunosByResponsavel.module.css';

interface AlunosByResponsavelProps {
  responsavelId: number;
  responsavelNome: string;
}

export const AlunosByResponsavel: React.FC<AlunosByResponsavelProps> = ({
  responsavelId,
  responsavelNome,
}) => {
  const [alunos, setAlunos] = useState<Aluno[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAlunos = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await alunosService.getByResponsavel(responsavelId);
        setAlunos(data);
      } catch (err) {
        console.error('Erro ao carregar alunos do responsável:', err);
        setError('Erro ao carregar alunos');
        setAlunos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAlunos();
  }, [responsavelId]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Users size={20} />
        <h3>Alunos de {responsavelNome}</h3>
      </div>

      {loading && (
        <div className={styles.loadingState}>
          <div className={styles.spinner} />
          Carregando alunos...
        </div>
      )}

      {error && (
        <div className={styles.errorState}>
          <p>{error}</p>
        </div>
      )}

      {!loading && alunos.length === 0 && (
        <div className={styles.emptyState}>
          <Users size={32} />
          <p>Nenhum aluno vinculado a este responsável</p>
        </div>
      )}

      {!loading && alunos.length > 0 && (
        <div className={styles.alunosList}>
          {alunos.map((aluno) => (
            <div key={aluno.id} className={styles.alunoItem}>
              <div className={styles.alunoInfo}>
                <div className={styles.alunoNome}>{aluno.nome}</div>
                <div className={styles.alunoDetails}>
                  <span className={styles.matricula}>{aluno.matricula}</span>
                  {aluno.email && <span className={styles.email}>{aluno.email}</span>}
                </div>
              </div>
              <div className={styles.alunoStatus}>
                <span className={`${styles.badge} ${aluno.ativo ? styles['badge--active'] : styles['badge--inactive']}`}>
                  {aluno.ativo ? '✓ Ativo' : '✗ Inativo'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
